import { render, staticRenderFns } from "./grantFoivCards.vue?vue&type=template&id=34249c1b&scoped=true&"
import script from "./grantFoivCards.vue?vue&type=script&lang=js&"
export * from "./grantFoivCards.vue?vue&type=script&lang=js&"
import style0 from "./grantFoivCards.vue?vue&type=style&index=0&id=34249c1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34249c1b",
  null
  
)

export default component.exports